import React from "react";
import Footer from "./Footer";
import "../css/contactus.scss";
import Header from "./Header";
import { Link } from "react-router-dom";

function Contact() {
  return (
    <div className="color-scheme color-scheme--scheme-1">
      <Header />

      <main className="contact-page">
        {/* Hero Section */}
        <section className="contact-hero">
          <div className="hero-overlay"></div>
          <div className="hero-content">
            <h1>Contact Us</h1>
          </div>
        </section>

        {/* Contact Information Section */}
        <section className="contact-info-section">
          <div className="contact-container">
            {/* By Email */}
            <div className="contact-method">
              <h2>By Email</h2>
              <p>
                <Link to="mailto:shop@bernicemy.blog">shop@bernicemy.blog</Link>{" "}
                for the quickest answer any time of the day
              </p>
            </div>

            {/* Live Chat */}
            <div className="contact-method">
              <h2>Live Chat</h2>
              <p>Monday thru Friday 9:00am - 5:00pm Central</p>
            </div>

            {/* By Phone */}
            <div className="contact-method">
              <h2>By Phone</h2>
              <p>
                <Link to="tel:1-877-757-3934">1.877.757.3934</Link> - Monday
                thru Friday 9:00am - 5:00pm Central
              </p>
            </div>

            {/* By Mail */}
            <div className="contact-method">
              <h2>By Mail</h2>
              <p>Bernicemy Customer Support</p>
              <p>114 North Court Street</p>
              <p>Florence, AL 35630</p>
            </div>

            {/* Wholesale Inquiries */}
            <div className="contact-method">
              <h2>Wholesale Inquiries</h2>
              <p>
                <Link to="mailto:shop@bernicemy.blog">shop@bernicemy.blog</Link>
              </p>
            </div>

            {/* Press Contact */}
            <div className="contact-method">
              <h2>Press Contact</h2>
              <p>
                <Link to="mailto:shop@bernicemy.blog">shop@bernicemy.blog</Link>
              </p>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default Contact;
